import MainLogo from '../../../../assets/img/RJ_V1/Main-logo.png';


const HeaderRJV1 = () => {

  return (
    <>
     <header className="site-header-rj pb-3 w-100 flex-shrink-0">
        <div className="d-flex mw-1300 mx-auto align-items-center justify-content-center justify-content-md-start px-3 gap-3 pt-4">
            <a href="">
                <img src={MainLogo} className="logo-img" alt="Main Logo"/>
            </a>
        </div>
    </header>



    </>
  )
}
export default HeaderRJV1;